// extracted by mini-css-extract-plugin
export default {"root":"Report_root__ZvyFw"};